import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { initialState, OpenModalPayload } from "./modal.types";

const modalSlice = createSlice({
    name: "modal",
    initialState,
    reducers: {
        openModal: (state, { payload }: PayloadAction<OpenModalPayload>) => {
            state.modalName = payload?.modalName;
            state.data = payload?.data || {};
            state.isOpen = true;
        },
        setModalData: (state, { payload }) => {
            state.data = payload || {};
        },
        closeModal: (state) => {
            state.modalName = "";
            state.isOpen = false;
            state.data = {};
        },
        clearModalState: (state) => {
            state.modalName = "";
            state.isOpen = false;
            state.data = {};
        },
    },
});

export const { openModal, closeModal, setModalData, clearModalState } =
    modalSlice.actions;
export default modalSlice.reducer;
